import { axiosInstance as axios } from "services";

export const fetchAllSeries = async (params) => {
  const { data } = await axios.get("/pricing/master/material", { params });
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch material data");
  return data;
};

